/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SearchBusinessMemoriesRequestBody,
  SearchBusinessMemoriesRequestBody$Outbound,
  SearchBusinessMemoriesRequestBody$outboundSchema,
} from "../components/searchbusinessmemoriesrequestbody.js";

export type SearchBusinessMemoriesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SearchBusinessMemoriesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  searchBusinessMemoriesRequestBody: SearchBusinessMemoriesRequestBody;
};

/** @internal */
export type SearchBusinessMemoriesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SearchBusinessMemoriesSecurity$outboundSchema: z.ZodMiniType<
  SearchBusinessMemoriesSecurity$Outbound,
  SearchBusinessMemoriesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function searchBusinessMemoriesSecurityToJSON(
  searchBusinessMemoriesSecurity: SearchBusinessMemoriesSecurity,
): string {
  return JSON.stringify(
    SearchBusinessMemoriesSecurity$outboundSchema.parse(
      searchBusinessMemoriesSecurity,
    ),
  );
}

/** @internal */
export type SearchBusinessMemoriesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SearchBusinessMemoriesRequestBody: SearchBusinessMemoriesRequestBody$Outbound;
};

/** @internal */
export const SearchBusinessMemoriesRequest$outboundSchema: z.ZodMiniType<
  SearchBusinessMemoriesRequest$Outbound,
  SearchBusinessMemoriesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    searchBusinessMemoriesRequestBody:
      SearchBusinessMemoriesRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      searchBusinessMemoriesRequestBody: "SearchBusinessMemoriesRequestBody",
    });
  }),
);

export function searchBusinessMemoriesRequestToJSON(
  searchBusinessMemoriesRequest: SearchBusinessMemoriesRequest,
): string {
  return JSON.stringify(
    SearchBusinessMemoriesRequest$outboundSchema.parse(
      searchBusinessMemoriesRequest,
    ),
  );
}
